/**
 * This code was generated by Builder.io.
 */
import React from "react";
import styles from "./TableStyles.module.css";

interface HeaderItem {
  label: string;
  icon: string;
}

interface TableHeaderProps {
  headers: HeaderItem[];
  onSort: (label: string) => void;
}

const TableHeader: React.FC<TableHeaderProps> = ({ headers, onSort }) => {
  return (
    <header className={styles.tableHeader}>
      {headers.map((header, index) => (
        <div key={index} className={styles.headerItem}>
          <div className={styles.divider} />
          <h2 className={styles.headerLabel}>{header.label}</h2>
          <button
            className={styles.headerIcon}
            onClick={() => onSort(header.label)}
            aria-label={`Sort by ${header.label}`}
          >
            {header.icon}
          </button>
        </div>
      ))}
    </header>
  );
};

export default TableHeader;
